import React from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "./AuthProvider";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-background text-zinc-500 font-mono text-xs uppercase tracking-[0.3em]">
        Loading…
      </div>
    );
  }

  if (!user) {
    // Wallet-only sign-in lives on /about (has prominent Connect Wallet CTAs)
    setTimeout(() => navigate("/about", { replace: true }), 0);
    return null;
  }

  return children;
}
